import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=4dcabaaf&scoped=true"
import script from "./exam.vue?vue&type=script&lang=js"
export * from "./exam.vue?vue&type=script&lang=js"
import style0 from "./exam.vue?vue&type=style&index=0&id=4dcabaaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcabaaf",
  null
  
)

export default component.exports